import {Hydra} from '../generic/hydra';

import {LaboratoireReferenceInterface} from './LaboratoireReference';
import {AdresseInterface} from './Adresse';
import {UniteInsermInterface} from './UniteInserm';
import {UniteCnrsInterface} from './UniteCnrs';
import {UniversiteFaculteInterface} from './UniversiteFaculte';
import {PersonneResponsableInterface} from './PersonneResponsable';
import {Laboratoire as LaboratoireBaseInterface} from '../../interface/api/Laboratoire';

export type LaboratoireInterface = LaboratoireBaseInterface;

export class Laboratoire extends Hydra implements LaboratoireInterface {

    id?: number | null;

    /* Objet de type LaboratoireReference, cf API
     *                                        dédiée
     */
    laboratoireReference?: LaboratoireReferenceInterface | string | null;

    nom?: string | null;

    /* Unité, service,Equipe
     */
    division?: string | null;

    /* Objet de type Adresse
     */
    adresse?: AdresseInterface | null;

    /* Objet de type UniteInserm, cf API dédiée
     */
    uniteInserm?: UniteInsermInterface | string | null;

    /* Si l'unité Inserm n'est pas dans la liste, champ de saisie libre
     */
    uniteInsermOther?: string | null;

    /* Objet de type UniteCnrs, cf API dédiée
     */
    uniteCnrs?: UniteCnrsInterface | string | null;

    /* Si l'unité CNRS n'est pas dans la liste, champ de saisie libre
     */
    uniteCnrsOther?: string | null;

    /* Objet de type
     *                                     UniversiteFaculte, cf API dédiée
     */
    universiteFaculte?: UniversiteFaculteInterface | string | null;

    /* Si l'université n'est pas dans la liste, champ de saisie libre
     */
    universiteFaculteOther?: string | null;

    /* Pour un établissement de tutelle autre que ceux présentés précédement
     */
    autreEtablissementTutelleBool?: boolean | null;

    /* Pour un établissement de tutelle autre que ceux présentés précédement
     */
    autreEtablissementTutelleText?: string | null;

    /* Responsable de
     *                                       l'équipe
     */
    directeurDivision?: PersonneResponsableInterface | string | null;

    numeroIdentification?: string | null;

    dateCreation?: string | Date | null;

    dateDerniereModification?: string | Date | null;


    constructor(options: LaboratoireInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
